import React from "react";

import { Navbar } from "../../../components";
import { EmergingIndustries } from "./EmergingIndustries";

const EmergingIndustriesProject = () => {
  return (
    <div className="app">
      <Navbar />
      <EmergingIndustries />
    </div>
  );
};

export default EmergingIndustriesProject;
